import { DEFAULT_LOCALE, isLocale, type Locale } from '@nexa/content';

/**
 * Ngôn ngữ của trang, lấy từ `?lang=` của URL — KHÔNG từ `navigator.language`, cookie hay
 * localStorage (contract §1.2).
 *
 * Vì sao đúng nguồn này mà không phải nguồn nào khác: nginx chọn FILE để phục vụ cũng bằng
 * chính `?lang` đó (`map $arg_lang $lang_dir` trong `infra/docker/nginx/site.conf`). Hai bên
 * đọc cùng một giá trị nên cây React và HTML tĩnh không thể lệch nhau. Đọc `navigator` thì
 * lệch được, và hậu quả không phải một dòng chữ sai: 7 trang pháp lý nhúng nội dung bằng
 * `dangerouslySetInnerHTML`, mà React GỠ con của node đó khi hydrate mismatch (#418) ⇒ trang
 * TRẮNG, trong khi mọi phép đo tĩnh vẫn xanh. Đó là vé #18, xem `core/router/pageModules.ts`.
 *
 * Giá trị lạ (`?lang=fr`, `?lang=EN`, `?lang=`) ra locale mặc định thay vì ném lỗi: nginx đã
 * 301 chúng về URL trần trước khi tới đây, nên ca này chỉ xảy ra ở `pnpm dev` / `vite preview`
 * — nơi không có nginx — và ở đó đổ vỡ thì vô ích.
 *
 * Không truyền tham số ⇒ đọc URL hiện tại. Lúc prerender không có `window`, và ra
 * `DEFAULT_LOCALE` là ĐÚNG: đó chính là bản được prerender ra gốc `dist/`.
 */
export function localeFromSearch(search?: string): Locale {
  const raw = search ?? (typeof window === 'undefined' ? '' : window.location.search);
  const lang = new URLSearchParams(raw).get('lang') ?? undefined;
  return isLocale(lang) ? lang : DEFAULT_LOCALE;
}
